module.exports = __webpack_public_path__ + "img/play-btn.9a000413.svg";